import React from 'react'
import { useLocation } from 'react-router-dom';
import Header from '@Components/Header';
import Footer from '@Components/Footer';
import enableSiniestrosMenu from '@hooks/enableSiniestrosMenu';

function MainLayout(props) {
    const { children } = props;
    const { pathname } = useLocation();
    const isToolsRoute = pathname === '/tools' || pathname.startsWith('/tools/');
    const { isSiniestrosMenuEnabled } = enableSiniestrosMenu();

    return (
        <div className="app-layout">
            <Header
                {...props}
                showBackButton={false}
                showNotificationPanel
                showProfileBadge
                showNavbar={!isToolsRoute}
                showHamburgerMenu
                token={true}
                isSiniestrosMenuEnabled={isSiniestrosMenuEnabled}
            />
            <main className="app-content">
                <section className="master-page">
                    {children}
                </section>
            </main>
            <Footer />
        </div>
    )
}

export default MainLayout;
